/* eslint-env jquery */

"use strict";

$(window).on("load", () => {
    const Swiper = require("swiper").default;
    const Navigation = require("swiper").Navigation;

    if ($("div[class^='recommendation-slider']").length > 0) {
        if (!window.up4ProductsCarouselInitialized) {
            const carousels = $("div[class^='recommendation-slider']");

            carousels.each(function (index, carousel) {
                const selector = ".recommendation-slider" + $(carousel).data().id + " .swiper";
                const prevButton = ".recommendation-slider" + $(carousel).data().id + " .swiper-button-prev";
                const nextButton = ".recommendation-slider" + $(carousel).data().id + " .swiper-button-next";

                // eslint-disable-next-line no-unused-vars
                const up4ProductSwiper = new Swiper(selector, {
                    loop: true,
                    modules: [Navigation],
                    autoHeight: true,
                    setWrapperSize: true,
                    spaceBetween: 20,
                    slidesPerView: 4,
                    navigation: {
                        nextEl: nextButton,
                        prevEl: prevButton,
                    },
                    breakpoints: {
                        0: {
                            slidesPerView: 2,
                            spaceBetween: 30,
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 30,
                        },
                    },
                    on: {
                        init: function () {
                            $(carousel).removeClass("d-none").removeClass("invisible");
                        }
                    }
                });
            });

            window.up4ProductsCarouselInitialized = true;
        }
    }
});
